/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
	name: 'servicesPage',
	title: 'Services Page',
	type: 'document',
	fields: [
		{
			name: 'title',
			title: 'Page Title',
			type: 'string',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'header',
			title: 'Header Section',
			type: 'pageHeader',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'seo',
			title: 'SEO Settings',
			type: 'object',
			fields: [
				{
					name: 'metaTitle',
					title: 'Meta Title',
					type: 'string',
				},
				{
					name: 'metaDescription',
					title: 'Meta Description',
					type: 'text',
				},
			],
		},
	],
	preview: {
		select: {
			title: 'title',
		},
	},
};
